export default {
  default: () => import("/builds/webcontact/bad-peterstal-griesbach/layouts/default.vue"),
  gemeinde: () => import("/builds/webcontact/bad-peterstal-griesbach/layouts/gemeinde.vue")
}